import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import styles from "./Settings.module.css";
import SettingsMenu from "../menus/SettingsMenu";
import React from "react";

function Settings() {
  return (
    <main className={styles.main}>
      <Sidebar>
        <SettingsMenu />
      </Sidebar>

      <Outlet />
    </main>
  );
}

export default Settings;
